module.exports = __webpack_public_path__ + "img/case.093814ab.png";